import * as actionTypes from './actionTypes'
import { categoryService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function getCategories({ page = constants.GET_ALL_ITEMS, filter, reset } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_CATEGORIES })

            dispatch({ type: actionTypes.FETCH_CATEGORIES })

            const response = await categoryService.getAll(page, filter)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_CATEGORIES_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_CATEGORIES_SUCCESS,
                payload: {
                    categories: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_CATEGORIES_FAILURE)
        }
    }
}
export function resetCategories() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_CATEGORIES
        })
    }
}
export function getCategory(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_CATEGORY })
            dispatch({ type: actionTypes.FETCH_CATEGORY })

            const response = await categoryService.get(id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_CATEGORY_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_CATEGORY_SUCCESS,
                payload: { category: data }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_CATEGORY_FAILURE)
        }
    }
}

export function resetCategory() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_CATEGORY
        })
    }
}
export function createCategory(category, onSuccess) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.CREATE_CATEGORY })

            const response = await categoryService.create(category)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.CREATE_CATEGORY_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.CREATE_CATEGORY_SUCCESS,
                payload: {
                    category: data
                }
            })


            dispatch({ type: actionTypes.RESET_CREATE_CATEGORY })

            onSuccess()
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.CREATE_CATEGORY_SUCCESS)
        }
    }
}
export function resetCreateCategory() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_CREATE_CATEGORY
        })
    }
}

export function updateCategory(id, category, onSuccess) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.UPDATE_CATEGORY })

            const response = await categoryService.update(id, category)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.UPDATE_CATEGORY_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.UPDATE_CATEGORY_SUCCESS,
                payload: { category: data }
            })

            onSuccess()
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.UPDATE_CATEGORY_FAILURE)
        }
    }
}

export function resetUpdateCategory() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_UPDATE_CATEGORY
        })
    }
}
export function deleteCategory(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.DELETE_CATEGORY })

            const response = await categoryService.deleteCategory(id)

            dispatch({
                type: actionTypes.DELETE_CATEGORY_SUCCESS,
                payload: {
                    category: { id }
                }
            })

            dispatch({ type: actionTypes.RESET_DELETE_CATEGORY })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.DELETE_CATEGORY_FAILURE)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/category/actions.js